<template>
  <div>
    <div class="main-wrapper signin-form center signin-wrapper-padding">
      <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>
	    <div class="text-align-center margin-bottom-20" style="font-size: 14px; color: #0C2E3E; font-weight: 600; margin-top: 30px;">
        The link you are trying to access is either expired, already used or invalid.
      </div>
      <div class="text-align-center margin-bottom-35" style="font-size: 14px; color: #0C2E3E;">
        If you have any questions, please contact Mentor Mentee Team at (888) 800-9250 or info@mentormentee.com.
      </div>
      
    </div>
  </div>
</template>
<style scoped>
.mm-logo img{ width: 240px; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';
import axios from 'axios';
import store from '../store/store.js';

export default {
  data: function () {
    return {
    }
  },
  methods: {
  	navigate(path) {
  	  router.push(path);
  	},
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
  },
  created() {

  },
}
</script>

<style scoped>
.main-wrapper {
    width: 45%;
    transform: translateY(20%);
    background-color: #e5e5e5;
    border-radius: 10px;
    margin-bottom: 10px;
    min-height: 375px;
}
.signin-wrapper-padding {
    padding: 3%;
}
</style>


// WEBPACK FOOTER //
// src/components/token_validation_failed.vue